const namespaced = true

const state = {
  minimumOrderCoinRollsSettings: {}
}

const mutations = {
  setOverrideMinimumOrderCoinRollsSettings (state, data) {
    state.minimumOrderCoinRollsSettings = data.minimumOrderCoinRollsSettings
  }
}

const getters = {
  getOverrideMinimumOrderCoinRollsSettings: (state) => {
    return state
  }
}

export default {
  namespaced,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/general/overrideMinimumOrderCoinRollsSettings.js